import React from 'react'
import css from './style.css'
import { Grid, GridItem } from '../grid'

const checkForImageFile = (img) => {
  if (!img) { return null }
  const extension = img.split('.').pop()
  const allowableExtensions = ['jpg', 'jpeg', 'gif', 'png', 'svg', 'tif', 'tiff']
  return allowableExtensions.indexOf(extension.toLowerCase()) !== -1
}

const DiamondPhoto = props => {
  const classNames = [
    props.small ? css.small : '',
    css.photo
  ].join(' ')

  const imgClasses = (options = { external: false }) => [
    options.external ? css.externalImg : css.noImg,
    props.summary ? css.summary : '',
    props.compare ? css.compare : '',
    css.diamond
  ].join(' ')

  const secondaryImgClasses = (options = { external: false }) => [
    options.external ? css.externalSecondaryImg : css.secondaryNoImg,
    props.summary ? css.summary : '',
    css.diamond
  ].join(' ')

  const renderFirstImage = (imageUrl) => {
    var hasPhotoExtension = checkForImageFile(imageUrl)
    if (imageUrl) {
      if (hasPhotoExtension) {
        return <div className={props.compare ? css.compare : css.primary}><a href={imageUrl} target='_blank' rel='noreferrer'><img className={classNames} src={imageUrl} /></a></div>
      } else {
        return <div className={props.compare ? css.compare : css.primary}><a href={imageUrl} target='_blank' rel='noreferrer'><div className={imgClasses({external: true})} /></a></div>
      }
    } else {
      return <div className={props.compare ? css.compare : css.primary}><div className={imgClasses()} /></div>
    }
  }

  const renderSecondaryImage = (imageUrl) => {
    var hasPhotoExtension = checkForImageFile(imageUrl)
    if (imageUrl) {
      if (hasPhotoExtension) {
        return <div className={css.secondary}><a href={imageUrl} target='_blank' rel='noreferrer'><img className={classNames} src={imageUrl} /></a></div>
      } else {
        return <div className={css.secondary}><a href={imageUrl} target='_blank' rel='noreferrer'><div className={secondaryImgClasses({external: true})} /></a></div>
      }
    } else {
      return ''
    }
  }

  return (
    <Grid>
      <GridItem col='1/2'>
        {renderFirstImage(props.firstImageURL)}
      </GridItem>
      <GridItem col='1/2'>
        <Grid>
          <GridItem col='1/1' customStyle={css.narrowGridFirst}>
            {renderSecondaryImage(props.secondImageURL)}
          </GridItem>
          <GridItem col='1/1' customStyle={css.narrowGridSecond}>
            {renderSecondaryImage(props.thirdImageURL)}
          </GridItem>
        </Grid>
      </GridItem>
    </Grid>
  )
}

export default DiamondPhoto



// WEBPACK FOOTER //
// ./src/components/diamond-photo/index.js